import { colors } from '../../../constants';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    backgroundColor: colors.parimary,
  },
  textEdit: {
    color: '#ffffff',
    marginRight: '4px',
  },
  field: {
    marginBottom: theme.spacing.unit * 2,
  },
  activeLabel: {
    marginBottom: theme.spacing.unit * 2,
    fontSize: 14,
  },
  actions: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
});

export default styles;
